<p-toast position="top-right"></p-toast>

<p-sidebar [(visible)]="showAddEditPromotionSideBar"
           [position]="'right'"
           [baseZIndex]="10000"
           (onHide)="cancel()"
           [style]="{width:'700px'}">
    <ng-template pTemplate="header">
        <div class="sidebar-header-title">{{sideBarHeaderTitle}}</div>
        <div class="sidebar-header-sub-title"></div>
    </ng-template>

    <div *ngIf="loading" style="text-align: center; padding: 30px;">
        <p-progressSpinner [style]="{width: '40px', height: '40px'}" styleClass="custom-spinner" strokeWidth="5"
                           fill="var(--surface-ground)" animationDuration="1s"></p-progressSpinner>
    </div>

    <div class="promo-content" *ngIf="!activePromoType && !loading">
        <div class="promo-content-center-block">
            <div class="flex flex-row flex-wrap">
                <div class="promo-item-discount" (click)="changePromoType(promoTypeEnum.PercentageDiscount)">
                    <div class="promo-item-discount-block">
                        <img src="/XpressApp/assets/images/promo/percentage-discount.svg" />
                        <div class="promo-item-discount__title">Percentage Discount</div>
                        <div class="promo-item-discount__info">Offers customers a percentage discount off the original price of your items.</div>
                        <div class="promo-item-discount__info">e.g. 20% Off</div>
                    </div>
                </div>

                <div class="promo-item-discount" (click)="changePromoType(promoTypeEnum.FixedAmountDiscount)">
                    <div class="promo-item-discount-block">
                        <img src="/XpressApp/assets/images/promo/fix-amount-discount.svg" />
                        <div class="promo-item-discount__title">Fixed Amount Discount</div>
                        <div class="promo-item-discount__info">Offers customers a fixed amount discount off the original price of your items</div>
                        <div class="promo-item-discount__info">e.g. ₱100 Off</div>
                    </div>
                </div>

                <div class="promo-item-discount" (click)="changePromoType(promoTypeEnum.DeliveryFeeDiscount)">
                    <div class="promo-item-discount-block">
                        <img src="/XpressApp/assets/images/promo/delivery-fee-discount.svg" />
                        <div class="promo-item-discount__title">Delivery Fee Discount</div>
                        <div class="promo-item-discount__info">Offer customers a discount off the delivery fee when they reached a minimum order requirement.</div>
                        <div class="promo-item-discount__info">e.g. ₱50 off delivery fee with ₱100 minimum order</div>
                    </div>
                </div>

                <div class="promo-item-discount" (click)="changePromoType(promoTypeEnum.FreeItemPromo)">
                    <div class="promo-item-discount-block">
                        <img src="/XpressApp/assets/images/promo/free-item-promo.svg" />
                        <div class="promo-item-discount__title">PFree Item Promo</div>
                        <div class="promo-item-discount__info">Offers customers free items from your catalogue when they spend a minimum order amount,</div>
                        <div class="promo-item-discount__info">e.g. Spend a minimum of ₱100 and get a free gift</div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div *ngIf="activePromoType && !loading">
        <div class="bx-pager bx-default-pager">
            <div class="bx-pager-item active" (click)="changeActiveMenuTab(menuTab.PromoDetails)">
                <a class="bx-pager-link " data-slide-index="0">Promo Details</a>
                <div class="arrow">

                </div>
            </div>
            <div class="bx-pager-item" [class.active]="checkIsActiveMenu(menuTab.Mechanics)" (click)="changeActiveMenuTab(menuTab.Mechanics)">
                <a class="bx-pager-link" data-slide-index="1">Mechanics</a>
                <div class="arrow">

                </div>
            </div>
            <div class="bx-pager-item"
                 [class.active]="checkIsActiveMenu(menuTab.Validity)" (click)="changeActiveMenuTab(menuTab.Validity)">
                <a class="bx-pager-link" data-slide-index="2">Validity</a>
                <div class="arrow">

                </div>
            </div>
            <div class="bx-pager-item" [class.active]="checkIsActiveMenu(menuTab.Products)" (click)="changeActiveMenuTab(menuTab.Products)">
                <a class="bx-pager-link" data-slide-index="3">Products</a>
                <div class="arrow">

                </div>
            </div>
            <div class="bx-pager-item" [class.active]="checkIsActiveMenu(menuTab.Locations)" (click)="changeActiveMenuTab(menuTab.Locations)">
                <a class="bx-pager-link" data-slide-index="3">Locations</a>
                <div class="arrow">

                </div>
            </div>
            <div class="bx-pager-item" [class.active]="checkIsActiveMenu(menuTab.Preview)" (click)="changeActiveMenuTab(menuTab.Preview)">
                <a class="bx-pager-link" data-slide-index="3">Preview</a>
            </div>
        </div>

        <div *ngIf="activeMenuTab === menuTab.PromoDetails">
            <p-scrollPanel [style]="{width:'100%', height: 'calc(100vh - 190px)'}"
                           [styleClass]="'app-scrollpanel'">
                <div class="flex flex-row">
                    <div class="col-5 p-0 pr-4">
                        <div class="sidebar-field-block">
                            <div class="sidebar-field__label">Promo Name <span class="sidebar-field__label-info">(Published name)</span></div>
                            <input type="text" [(ngModel)]="promo.Name" placeholder="Max 50 Characters" pInputText />
                            <!--<div class="sidebar-field__error-message">Required</div>-->
                        </div>
                        <div class="sidebar-field-block">
                            <div class="sidebar-field__label">Internal Reference <span class="sidebar-field__label-info">(Not Published)</span></div>
                            <input type="text" [(ngModel)]="promo.Code" placeholder="Optional" pInputText />
                        </div>
                    </div>
                    <div class="col-7 p-0 pl-4">
                        <div class="sidebar-field-block">
                            <div class="sidebar-field__label">Promo Creative</div>
                            <div class="partner-promo-img-block" (click)="handleImageClick('idImgInput')">
                                <div class="partner-promo-upload-block" *ngIf="!promo.ImageUrl">
                                    <img src="/XpressApp/assets/images/upload-img.svg" />
                                    <div class="partner-promo-upload-block__title">Upload image</div>
                                    <div class="partner-promo-upload-block__subtitle">Minimum 600x320 pixels</div>
                                </div>
                                <img class="partner-promo-img" src="{{promo.ImageUrl}}" *ngIf="promo.ImageUrl"/>
                                <input id="idImgInput"
                                       type="file"
                                       accept="image/*"
                                       style="display: none"
                                       (change)="handleImageChange($event)" required />
                            </div>
                        </div>
                    </div>
                </div>

                <div class="sidebar-field-block">
                    <div class="sidebar-field__label">Promo Description <span class="sidebar-field__label-info">(Published)</span></div>
                    <textarea rows="7" cols="30" pInputTextarea [(ngModel)]="promo.Description" placeholder="Add Description"></textarea>
                </div>

                <div class="sidebar-field-block">
                    <div class="sidebar-field__label">Promo Terms & Conditions <span class="sidebar-field__label-info">(Published)</span></div>
                    <textarea rows="7" cols="30" pInputTextarea [(ngModel)]="promo.HtmlView" placeholder="Add Bullet point"></textarea>
                </div>
            </p-scrollPanel>

            <div class="flex justify-content-end mrg-10-0px">
                <button class="bluedark-btn" pButton label="Next" (click)="changeActiveMenuTab(menuTab.Mechanics)"></button>
            </div>
        </div>

        <div *ngIf="activeMenuTab === menuTab.Mechanics">
            <p-scrollPanel [style]="{width:'100%', height: 'calc(100vh - 190px)'}"
                           [styleClass]="'app-scrollpanel'">
                <div class="partner-promo-title">Peso Discount</div>
                <div class="flex flex-row">
                    <div class="col-5 p-0 pr-4">
                        <div class="sidebar-field-block">
                            <div class="sidebar-field__label">Peso Discount <span class="sidebar-field__label-info"></span></div>
                            <span class="partner-promo-peso">₱</span> <p-inputNumber inputId="discountValue" [minFractionDigits]="2" [ngStyle]="{'width': '100px;'}"
                                                                                     [(ngModel)]="promo.UseAmount" placeholder="50"></p-inputNumber>
                        </div>
                    </div>
                    <div class="col-7 p-0 pl-4">
                        <div class="sidebar-field-block">
                            <div class="sidebar-field__label">Minimum Spend <span class="sidebar-field__label-info"></span></div>
                            <span class="partner-promo-peso">₱</span> <p-inputNumber inputId="minSpend" [minFractionDigits]="2" [ngStyle]="{'width': '100px;'}"
                                                                                     [(ngModel)]="promo.MinSpend" placeholder="50"></p-inputNumber>
                        </div>
                    </div>
                </div>

                <div class="partner-promo-title">Redemption Rules</div>
                <div class="flex flex-row">
                    <div class="col-6 p-0 pr-4">
                        <div class="sidebar-field-block">
                            <div class="sidebar-field__label">Total redemption limit <span class="sidebar-field__label-info"></span></div>
                            <div class="sidebar-field-block">
                                <p-radioButton name="noLimit"
                                               value="0"
                                               label="No Limit"
                                               (onClick)="limitClick(false)"
                                               [(ngModel)]="promo.selectedLimit"></p-radioButton>
                                <div class="partner-promo-redemption-info" style="width: 220px;">Promotions will run until the end of date and time</div>
                            </div>
                            <div class="sidebar-field-block">
                                <p-radioButton name="limit"
                                               value="1"
                                               label="Limit Redemption"
                                               (onClick)="limitClick(true)"
                                               [(ngModel)]="promo.selectedLimit"></p-radioButton>
                            </div>
                            <div class="sidebar-field-block" *ngIf="showLimit">
                                <p-inputNumber inputId="maxUseCount" [(ngModel)]="promo.MaxUseCount"
                                               placeholder="Maximum"
                                               [ngStyle]="{'width': '200px', 'margin-left': '25px;'}"></p-inputNumber>
                            </div>
                        </div>
                    </div>
                    <div class="col-6 p-0 pl-4">
                        <div class="sidebar-field-block">
                            <div class="sidebar-field__label">Customer redemption limit <span class="sidebar-field__label-info"></span></div>
                            <div class="sidebar-field-block">
                                <p-radioButton name="registeredTaxGroup"
                                               value="0"
                                               label="No Limit"
                                               (onClick)="limitPerDayClick(false)"
                                               [(ngModel)]="promo.selectedLimitPerDay"></p-radioButton>
                                <div class="partner-promo-redemption-info" style="width: 220px;">Customer can redeem as often as They like</div>
                            </div>
                            <div class="sidebar-field-block">
                                <p-radioButton name="registeredTaxGroup"
                                               value="1"
                                               label="Limit Redemption"
                                               (onClick)="limitPerDayClick(true)"
                                               [(ngModel)]="promo.selectedLimitPerDay"></p-radioButton>
                            </div>
                            <div class="sidebar-field-block" *ngIf="showLimitPerDay">
                                <p-inputNumber inputId="MaxUsePerDayCount" [(ngModel)]="promo.MaxUsePerDayCount"
                                               placeholder="Maximum"
                                               [ngStyle]="{'width': '200px', 'margin-left': '25px'}"></p-inputNumber>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="partner-promo-title">What customer can avail this promo?</div>
                <div class="sidebar-field-block">
                    <div class="sidebar-field-block">
                        <p-radioButton inputId="customer1" name="customerGroup"
                                       value="{{promoAvailableType.AllCustomers}}"
                                       label="All customers"
                                       [(ngModel)]="promo.PromoAvailableType"></p-radioButton>
                        <div class="partner-promo-redemption-info">Promotions will be shown to all users</div>
                    </div>
                    <div class="sidebar-field-block">
                        <p-radioButton inputId="customer2" name="customerGroup"
                                       value="{{promoAvailableType.NewCustomers}}"
                                       label="New customers ONLY"
                                       [(ngModel)]="promo.PromoAvailableType"></p-radioButton>
                        <div class="partner-promo-redemption-info">Promotions will be shown to new customers only</div>
                    </div>
                    <div class="sidebar-field-block">
                        <p-radioButton inputId="customer3" name="customerGroup"
                                       value="{{promoAvailableType.ReturningCustomers}}"
                                       label="Returning customers ONLY"
                                       [(ngModel)]="promo.PromoAvailableType"></p-radioButton>
                        <div class="partner-promo-redemption-info">Promotions will be shown to existing customers only</div>
                    </div>
                </div>
            </p-scrollPanel>

            <div class="flex justify-content-end mrg-10-0px">
                <button class="bluedark-btn" pButton label="Next" (click)="changeActiveMenuTab(menuTab.Validity)"></button>
            </div>
        </div>

        <div *ngIf="activeMenuTab === menuTab.Validity">
            <p-scrollPanel [style]="{width:'100%', height: 'calc(100vh - 190px)'}"
                           [styleClass]="'app-scrollpanel'">
                <div class="partner-promo-title">Promo validity period</div>
                <div class="flex flex-row">
                    <div class="col-6 p-0 pr-4">
                        <div class="sidebar-field-block">
                            <div class="sidebar-field__label">Start date and time <span class="sidebar-field__label-info"></span></div>
                            <div class="flex flex-row">
                                <div class="sidebar-field-column">
                                    <p-calendar inputId="startDate" [(ngModel)]="promo.StartedAt"></p-calendar>
                                </div>
                                <div class="sidebar-field-column">
                                    <p-calendar [timeOnly]="true" inputId="timeonly" [(ngModel)]="promo.StartedAtTime"></p-calendar>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-6 p-0 pl-4">
                        <div class="sidebar-field-block">
                            <div class="sidebar-field__label">End date and time <span class="sidebar-field__label-info"></span></div>
                            <div class="flex flex-row">
                                <div class="sidebar-field-column">
                                    <p-calendar inputId="endDate" [(ngModel)]="promo.ValidUntil"></p-calendar>
                                </div>
                                <div class="sidebar-field-column">
                                    <p-calendar [timeOnly]="true" inputId="timeonly" [(ngModel)]="promo.ValidUntilTime"></p-calendar>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="sidebar-field-block">
                    <div class="sidebar-field__label">Applicable days <span class="sidebar-field__label-info"></span></div>

                    <p-selectButton [options]="daysWeek" [(ngModel)]="promo.SelectedDayWeeks" class="select-week"
                                    [multiple]="true" optionLabel="name" optionValue="value"></p-selectButton>
                </div>

                <div class="partner-promo-title">Time of day</div>
                <div class="sidebar-field-block">
                    <div class="sidebar-field-block">
                        <p-radioButton name="timeOfDay"
                                       value="0"
                                       label="While the store is open"
                                       (onClick)="betweenTimeOfDayClick(false)"
                                       [(ngModel)]="promo.whileStoreIsOpen"></p-radioButton>
                        <div class="partner-promo-redemption-info">Customers can redeem as often as they like</div>
                    </div>
                    <div class="sidebar-field-block">
                        <p-radioButton name="timeOfDay"
                                       value="1"
                                       label="Between"
                                       (onClick)="betweenTimeOfDayClick(true)"
                                       [(ngModel)]="promo.whileStoreIsOpen"></p-radioButton>
                        <div class="flex flex-row col-6" *ngIf="showBetweenTimeOfday">
                            <div class="sidebar-field-column">
                                <p-calendar [timeOnly]="true" inputId="timeonly" [(ngModel)]="promo.BetweenStartTime"></p-calendar>
                            </div>
                            <div class="sidebar-field-column">
                                <p-calendar [timeOnly]="true" inputId="timeonly" [(ngModel)]="promo.BetweenEndTime"></p-calendar>
                            </div>
                        </div>
                    </div>
                </div>
            </p-scrollPanel>

            <div class="flex justify-content-end mrg-10-0px">
                <!--<button class="bluedark-btn" pButton label="Next" (click)="changeActiveMenuTab(menuTab.Products)"></button>-->
                <button class="bluedark-btn" pButton label="{{promoId > 0 ? 'Save' : 'Create'}}" (click)="clickSavePromo()"></button>
            </div>
        </div>
    </div>

    <!--<div *ngIf="loading" style="text-align: center; padding: 30px;">
        <p-progressSpinner [style]="{width: '40px', height: '40px'}" styleClass="custom-spinner" strokeWidth="5"
                           fill="var(--surface-ground)" animationDuration="1s"></p-progressSpinner>
    </div>-->
    <!--<div *ngIf="!loading">
        <p-scrollPanel [style]="{width:'100%', height: 'calc(100vh - 190px)'}"
                       [styleClass]="'app-scrollpanel'">
            <div class="flex flex-row">
                <div class="merchant-column merchant-column-50">
                    <div class="merchant-form">
                        <div class="merchant-label">Payout Account Type</div>
                        <p-dropdown placeholder="Select" [(ngModel)]="payment.PayoutAccountTypeId" [options]="payoutAccountTypes"
                                    optionLabel="name" optionValue="value" [showClear]="true"></p-dropdown>
                    </div>
                </div>
                <div class="merchant-column merchant-column-50">
                </div>
            </div>

            <div class="flex flex-row" *ngIf="payment.PayoutAccountTypeId !== undefined && payment.PayoutAccountTypeId === payoutAccountTypeEnum.EWallet">
                <div class="merchant-column merchant-column-50">
                    <div class="merchant-form">
                        <div class="merchant-label">E-Wallet Details</div>
                        <p-dropdown placeholder="Select" [(ngModel)]="payment.WalletDetailId" [options]="walletDetails"
                                    optionLabel="name" optionValue="value" [showClear]="true"></p-dropdown>
                    </div>
                </div>
                <div class="merchant-column merchant-column-50">
                </div>
            </div>

            <div class="flex flex-row" *ngIf="payment.PayoutAccountTypeId !== undefined && payment.PayoutAccountTypeId !== null">
                <div class="merchant-column merchant-column-50">
                    <div class="merchant-form">
                        <input type="text" [(ngModel)]="payment.AccountName" placeholder="Account Name" pInputText />
                    </div>
                </div>
                <div class="merchant-column merchant-column-50">
                    <div class="merchant-form">
                        <input type="text" [(ngModel)]="payment.AccountNumber" placeholder="Account Number" pInputText />
                    </div>
                </div>
            </div>
        </p-scrollPanel>
        <hr class="hr-filter" />
        <div class="flex justify-content-end mrg-10-0px">
            <button class="btn-darkblue" pButton label="{{(merchantId > 0 ? 'Update' : 'Add')}}"></button>
        </div>
    </div>-->

</p-sidebar>
